<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Site />
        <LateralMenu_Site />

        <div class="page-content" id="entreprises">
            <div class="logo"></div>
            <div class="habillage-header"></div>

            <div id="ent-header" class="content">
                <div>
                    <div class="bandeau">
                        <span>- Offres Entreprises -</span>
                        <div>
                            <div class="bandeau-wordings">
                                Partage, cohésion, communication et convivialité...
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div>
                        <span>Une activité idéale de Team Building</span>
                        <h3>
                            L’Escape Game en entreprise est l’activité idéale de team buiding, pour souder ses équipes et favoriser la communication.
                        </h3>
                        <br />
                        <h3>
                            Chaque membre devra apprendre à écouter et à participer. Les maîtres-mots sont : coopération, écoute, communication. 
                            Renforcez le sentiment d’accomplissement d’un objectif à plusieurs.
                        </h3>
                        <br />
                        <h3>
                            L’Escape Game pour les professionnels a l’avantage de séduire un grand nombre de personnalités différentes, 
                            hommes ou femmes, et il n’y a pas d’âge pour l’apprécier.
                        </h3>

                        <a href="/contact">Devis</a>
                    </div>
                </div>
            </div>

            <div class="content-separateur">Options supplémentaires</div>

            <div id="ent-options" class="content">
                <div>
                    <div v-observe-visibility="{ callback: ovCallbackOptions, intersection: ovOptions, once: true }">
                        <span>Petit déjeuner + Escape Game</span>
                        <div>
                            Savourez un petit-déjeuner "réveille-méninges" dans notre salon
                            <br />privatisé toute la matinée et profitez de nos Escape Game.
                            <br />Une façon conviviale de commencer la journée.
                        </div>
                        <ul>
                            <li>- Salon privatisé toute la matinée jusqu'à 11h.</li>
                            <li>- Buffet de viennoiseries, café, thé et jus de fruits.</li>
                            <li>- Jusqu'à 20 personnes.</li>
                            <li>- Profitez de nos Escape Game.</li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div v-observe-visibility="{ callback: ovCallbackOptions, intersection: ovOptions, once: true }">
                        <span>Soirée privée + Escape Game</span>
                        <div>
                            Privatisez notre salon pour une soirée. Profitez de nos Escape
                            <br />Game sans stress, pour votre événementiel, avec possibilité de
                            <br />cocktail dinatoire.
                        </div>
                        <ul>
                            <li>- Salon privatisé toute la soirée jusqu'à 23h30.</li>
                            <li>- Apéritif dinatoire traiteur.</li>
                            <li>- Jusqu'à 40 personnes.</li>
                            <li>- Accès à nos Escape Game.</li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div v-observe-visibility="{ callback: ovCallbackOptions, intersection: ovOptions, once: true }">
                        <span>Escape Game mobiles</span>
                        <div>
                            Quand l'Escape Game se déplace à domicile. Dans vos
                            <br />locaux ou en extérieur sous barnum, découvrez nos
                            <br />scénarios spécialement adaptés à vos événementiels.
                        </div>
                        <ul>
                            <li>- Scénarios de 30 à 60 minutes.</li>
                            <li>- Jusqu'à 100 joueurs sur la journée.</li>
                            <li>- Installation dans le lieu de votre choix.</li>
                            <li>- Déplacement dans toute la France.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="content-separateur">Et aussi...</div>

            <div id="jeux-de-piste" class="content">
                <div class="column left">
                    <div>
                        <div v-observe-visibility="{ callback: ovCallbackPadquest, intersection: ovOptions, once: true }">
                            <div class="icon host"></div>
                            <span>Accompagné par un animateur tout au long du parcours</span>
                        </div>
                        <div v-observe-visibility="{ callback: ovCallbackPadquest, intersection: ovOptions, once: true }">
                            <div class="icon gps"></div>
                            <span>Enigmes et défis GPS autour du patrimoine</span>
                        </div>
                    </div>
                </div><!--

                --><div class="column right">
                    <div>
                        <span v-observe-visibility="{ callback: ovCallbackPadquest, intersection: ovOptions, once: true }">
                            Nos jeux de piste
                            <br />en plein air
                        </span>
                        <span v-observe-visibility="{ callback: ovCallbackPadquest, intersection: ovOptions, once: true }">
                            <span>L'aventure continue, grandeur nature !</span>
                            Affrontez-vous en plein air de 2 à 6 équipes en
                            <br />simultané avec le système de tablettes
                            <br />interactives <span><i>pad</i>Quest®</span> (jusqu'à 36 personnes).

                            <p>&nbsp;</p>

                            Découvrez également nos défis "safari photo"
                            <br />pour de grands groupes jusqu'à 120
                            <br />personnes.
                        </span>

                        <a href="https://www.padquest.fr" target="_blank">Site dédié</a>
                    </div>
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <Footer 
            seo_contentH1="Nos offres entreprise d’escape game pour du team building ou séminaire indoor ou extérieur"
            seo_contentH2="Nos offres : petit déjeuner, soirée privée, activité de cohésion d’équipe, activité de loisir directement de l’entreprise,<br/>escape game et jeux de piste en plein air et à l’extérieur" />
    </div>
</template>

<script>
import HeaderMenu_Site from '../../components/HeaderMenu_Site.vue';
import LateralMenu_Site from '../../components/LateralMenu_Site.vue';
import Footer from '../../components/Footer.vue';

import anime from 'animejs/lib/anime.es';

export default {
    name: "Site_EntreprisesPage",
    components: {
        HeaderMenu_Site,
        LateralMenu_Site,
        Footer
    },
    data: () => ({
        ovOptions: {
            root: null,
            rootMargin: '0px 0px -50px 0px',
            treshold: 0
        }
    }),
    methods: {
        ovCallbackOptions(visible, entry) {
            if (!visible) {
                return;
            }

            anime({
                targets: entry.target,
                opacity: [0, 1],
                translateX: [-50, 0],
                duration: 500,
                easing: 'linear'
            });
        },
        ovCallbackPadquest(visible, entry) {
            if (!visible) {
                return;
            }

            anime({
                targets: entry.target,
                opacity: [0, 1],
                translateX: [-50, 0],
                duration: 500,
                easing: 'linear'
            });
        }
    }
}
</script>